import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addTrainingRes;
export const addTrainingTodo = createAsyncThunk('addTraining', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/add_training',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "training_title": val.training_title,
                "training_mode": val.training_mode,
                "classroom_type": val.classroom_type,
                "venue": val.venue,
                "employee": val.employee,
                "instructor_name": val.instructor_name,
                "course_wise": val.course_wise,
                "learning_track": val.learning_track,
                "link": val.link,
                "meeting": val.meeting,
                "password": val.password,
                "title": val.title,
                "start_date": val.start_date,
                "start_time": val.start_time,
                "end_date": val.end_date,
                "end_time": val.end_time,
                "type": val.type,
                "types_of_traininig": val.training_type,
                "created_by": user_id.vemp_code,
                "training_repeat": val.repeat_count,
                "training_interval": val.interval_count,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addTrainingRes = res.data
    } catch (error) {
        return addTrainingRes = error.response.data
    }
})